

export const BookingStepTopBar = () => {

    return (
        <div className="w-full fixed top-30 z-[9999] flex items-center justify-center gap-6 py-4 bg-white border-y">
            <span className="text-sm font-semibold text-primary">Cart</span>
            <span className="text-gray-400 text-sm font-semibold">----------------------------------------</span>
            <span className="text-sm font-semibold text-gray-400">Checkout</span>
        </div>
    )
}